module.exports = __webpack_public_path__ + "static/media/tv-music.4b671265.svg";